import type {
  NavItemStoryblok,
  SocialLinkStoryblok,
  AnchorLinkWithCssClassStoryblok,
} from "$types/components";
import { getContext, setContext } from "svelte";

export type AppContext = {
  footerNavigation: NavItemStoryblok[];
  socials: SocialLinkStoryblok[];
  footerBottomLinks: AnchorLinkWithCssClassStoryblok[];
  // TODO: import these from the CDN automatically and get the typings correct
  datasources: Record<string, object>[];
  pageType: string;
};

export function getAppContext<K extends keyof AppContext>(
  key: K,
): AppContext[K] {
  return getContext(key);
}

export function setAppContext<K extends keyof AppContext>(
  key: K,
  value: AppContext[K],
) {
  setContext(key, value);
}
